import { initialState } from "./state"

export const setBanners = (state, payload) => {
  state.banners = payload
}

export const reset = (state) => {
  const s = initialState()

  Object.keys(s).forEach((key) => {
    state[key] = s[key]
  })
}
